import { getkfDate, getBidByCompanyId } from '@/api/index.js';

/** 获取客服配置（对齐 PC seo-main/utils/kf.js fetchKfConfig） */
export async function fetchKfConfig({ companyId, userId, isGxzz }) {
	const isZS = import.meta.env.PROD ? '1' : '0';

	// 国械智造：统一走专属接口（不传 userId，不区分登录态）
	if (isGxzz) {
		return getBidByCompanyId({ companyId, isZS });
	}

	// 非国械智造：保持原逻辑
	if (userId) {
		const res = await getkfDate({
			companyId,
			isZS,
			userId,
		});
		if (res?.data) {
			delete res.data.bid;
		}
		return res;
	}

	return getkfDate({
		companyId,
		isZS,
	});
}
